import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export default function FAQAccordion({ items = [], idPrefix = 'faq', dark = false }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((item, i) => (
        <AccordionItem
          key={i}
          value={`${idPrefix}-${i}`}
          data-testid="faq-accordion-item"
          className={dark ? 'border-white/10' : 'border-slate-900/10'}
        >
          <AccordionTrigger
            className={
              dark
                ? 'text-left text-white hover:text-[#22D3EE] py-5 font-display font-semibold text-base transition-colors'
                : 'text-left text-slate-900 hover:text-[#2563EB] py-5 font-display font-semibold text-base transition-colors'
            }
          >
            {item.q}
          </AccordionTrigger>
          <AccordionContent className={dark ? 'text-slate-300 text-sm leading-relaxed pb-5' : 'text-slate-600 text-sm leading-relaxed pb-5'}>
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
